// extracted by mini-css-extract-plugin
export default {"products":"Is-z","card":"Js-z","oosMessaging":"Ks-z"};